import axios from 'axios'
import qs from 'qs'
axios.defaults.timeout = 15000;                        //响应时间
// axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'http://mahashri.cn';  //配置接口地址

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    if (res.status == 200) {
        return res.data;
    } else {
        return Promise.reject(res.data);
    }
    // return res;
}, (error) => {
    console.log(error);
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(params), { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } })
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
function fetchImg(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
function fetchFile(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, { param })
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 地址拼接
function fetchGeturl(url) {
    return new Promise((resolve, reject) => {
        axios.get(url)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function request({ method, url, param }) {
    if (method == 'Get') {
        return fetchGet(url, param);
    } else if (method == 'Post') {
        return fetchPost(url, param);
    } else if (method == 'Img') {
        return fetchImg(url, param);
    } else if (method == 'File') {
        return fetchFile(url, param);
    }else if(method == 'Gets') {
        return fetchGeturl(url)
    }
}